import React from "react";

type Props = {
  hand: "left" | "right";
  height?: string;
  width?: string;
  color?: {
    palm?: string;
    thumb?: string;
    first?: string;
    second?: string;
    third?: string;
    fourth?: string;
  };
};

const HandSVG: React.VFC<Props> = ({
  hand,
  height = "390",
  width = "450",
  // propsでcolorがない場合のデフォルト設定
  color = {
    palm: "#e6e6e6",
    thumb: "#e6e6e6",
    first: "#e6e6e6",
    second: "#e6e6e6",
    third: "#e6e6e6",
    fourth: "#e6e6e6",
  },
}) => {
  // 元のsvgは右手の画像なので左手は左右反転する。
  const transformArg = hand === "left" ? "scale(-1, 1)" : "scale(1, 1)";
  // propsで色情報が渡された場合、色情報がない指が真っ黒に表示されるため色情報を再定義。
  const palm = color.palm ?? "#e6e6e6";
  const thumb = color.thumb ?? "#e6e6e6";
  const first = color.first ?? "#e6e6e6";
  const second = color.second ?? "#e6e6e6";
  const third = color.third ?? "#e6e6e6";
  const fourth = color.fourth ?? "#e6e6e6";
  return (
    // svgは指毎のpathに分割しており、与えられたpropsに応じて指毎の色を変えられる。デフォルトはグレー。
    <svg
      width={width}
      height={height}
      transform={transformArg}
      viewBox="0 0 130 150"
      version="1.1"
      id="svg5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs2" />
      <g id="layer1">
        <path
          fill={palm}
          stroke="none"
          strokeWidth="0.389811"
          d="m 56.837021,142.09569 c -1.367279,-2.50033 -3.145652,-4.27439 -3.623238,-4.51936 -2.926974,-1.50133 -6.217192,-4.21852 -10.46856,-8.72475 -2.675255,-2.83563 -6.060548,-7.7102 -7.964897,-9.3325 -7.48647,-6.37765 -8.149925,-6.46584 -9.720378,-10.57717 -0.797605,-2.08807 -1.642293,-5.00748 -1.928051,-4.33631 0,0 3.854599,-2.75766 7.981719,-5.857719 4.127119,-3.100067 8.688808,-6.856877 9.35835,-7.569737 1.788803,-1.90453 3.834825,-5.30177 3.77513,-7.01973 -0.02421,-0.69661 0.860571,-3.48344 1.057487,-8.47551 0.170484,-4.32196 -0.444527,-7.70358 -0.1577,-8.02491 0.500867,-0.56111 11.635576,-4.58513 15.121361,-4.33864 2.044827,0.1446 10.449477,1.38517 20.138317,2.80207 0,0 5.08537,3.46553 8.50715,5.67995 l 6.22143,4.02621 c 1.67226,1.60979 3.30694,3.03173 5.340199,6.44644 l 5.34018,6.44644 -0.91714,4.46826 c -1.86208,9.071916 -2.63344,23.658926 -6.655519,28.766146 -2.12772,2.70176 0.14993,7.39787 1.15405,9.19847 1.591809,2.85444 1.153679,4.55706 0.755959,3.73772 -0.248664,-0.51227 -6.504299,4.23792 -19.207559,7.39597 -9.0925,2.26039 -19.800947,4.52858 -21.065674,4.11595 -0.418558,-0.13655 -1.296974,-1.11508 -3.042616,-4.30729 z"
          id="palm"
        />
        <path
          fill={thumb}
          stroke="none"
          strokeWidth="0.264583px"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeOpacity="1"
          d="m 23.725692,104.83214 c -0.27811,-1.21739 -1.829656,-3.97313 -8.469797,-12.137016 -3.00786,-5.03479 -7.406042,-7.75237 -11.4666245,-11.03262 -0.906321,-1.58091 -0.555776,-2.97748 0.728958,-4.23703 -2.169971,0.58201 4.2714534,-2.05531 9.1871845,-2.00616 2.138658,-0.38915 6.501013,2.09123 10.65667,4.30487 2.274366,2.50946 2.494103,4.05273 2.915829,5.69099 2.932923,5.24123 6.911519,6.76465 10.818662,8.54211"
          id="thumb"
        />
        <path
          fill={first}
          stroke="none"
          strokeWidth="0.264583px"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeOpacity="1"
          d="m 45.075554,68.170734 c -3.690217,-10.35107 -5.093691,-28.51052 -7.994121,-42.843367 -0.330623,-2.594401 0.250736,-4.411499 1.330638,-5.803677 1.437133,-1.344897 2.380289,-1.989902 2.927402,-2.073775 2.259088,-0.481812 3.463756,-0.05614 4.54731,0.47376 4.144531,6.117558 4.258216,12.538789 6.38706,18.808209 3.070219,18.42525 4.280963,17.32601 6.340774,25.14199 l 1.527341,2.01697 z"
          id="first"
        />
        <path
          fill={second}
          stroke="none"
          strokeWidth="0.264583px"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeOpacity="1"
          d="m 60.593218,63.800694 1.631477,-2.22005 c 0.782955,-5.25002 1.56591,-3.80339 2.348865,-19.70975 0.421122,-5.45103 1.069883,-11.04435 2.094306,-16.476137 0.767995,-4.980574 1.158555,-10.086959 1.354015,-15.258378 l 0.68244,-2.4454349 c 1.2999,-2.0839589 2.58658,-3.3986779 3.85306,-3.5387779 l 1.43478,-0.281731 c 2.04441,0.277171 3.00264,1.127092 3.84149,2.039964 l 1.12259,1.9721239 c 0.58448,2.4249239 0.23147,2.6764349 0.21962,3.7188619 0.22463,6.92284 0.14946,6.050668 0.20436,8.560525 l -0.5052,14.022894 c -0.0253,5.21124 -0.42325,9.86362 -0.82212,14.51457 l -0.33183,10.12085 1.65149,6.94155 1.00665,1.00274 z"
          id="second"
        />
        <path
          fill={third}
          stroke="none"
          strokeWidth="0.264583px"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeOpacity="1"
          d="m 80.506491,66.776004 c 3.5598,-4.72949 5.22615,-16.76438 7.35924,-25.62656 l 3.32135,-12.736643 3.74815,-8.08922 c 1.08436,-1.266248 2.5311,-1.817591 4.33904,-1.656358 1.729989,0.143947 2.843179,1.330762 3.725789,2.907474 l 0.17356,5.961224 -0.96014,6.412443 c -1.07476,4.3348 -1.56319,8.39398 -1.64328,12.26121 l -3.367099,18.81969 c -0.96855,4.69175 -2.0672,7.74046 -1.85132,11.00987 z"
          id="third"
        />
        <path
          fill={fourth}
          stroke="none"
          strokeWidth="0.264583px"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeOpacity="1"
          d="m 94.984601,76.219214 7.023459,-5.78069 c 2.80874,-2.35379 4.74889,-4.82667 6.58376,-7.31399 2.52846,-2.95247 5.16455,-5.58205 7.39372,-9.43239 0.9969,-1.79314 1.71156,-3.68036 4.08446,-5.01483 -0.0966,-0.37508 1.46515,-0.42574 3.21668,-0.43927 1.58071,0.52484 1.78149,1.30687 2.42986,2.00548 0.51547,0.35054 0.71467,1.91757 0.89094,3.57281 -3.80283,9.16216 -7.02296,13.08001 -10.52938,19.57452 -0.55417,0.81402 -0.71838,1.35951 -3.5985,3.7752 -1.97448,2.38362 -3.9275,4.81005 -5.05643,8.8802 l -1.63124,3.22301 z"
          id="fourth"
        />
      </g>
    </svg>
  );
};

export default HandSVG;
